<template>
  <div>
    <!-- 欢迎栏 -->
    <div class="welcome-bar">
      <span class="welcome-text">欢迎来到 广西共勉科技有限公司 官方商城！</span>
      <!-- <div class="welcome-actions">
        <a href="#" class="action-link">登录</a>
        <a href="#" class="action-link">订单</a>
      </div> -->
    </div>
    
    <!-- 原有的 Top 组件内容（如果有的话） -->
    <!-- 这里可以添加原有的 Top 组件内容 -->
  </div>
</template>

<script>
export default {
  name: 'Top'
}
</script>

<style lang="less" scoped>
.welcome-bar {
  height: 35px;
  width: 100%;
  background: #f8f8f8;
  border-bottom: 1px solid #e7e7e7;
  line-height: 35px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  
  .welcome-text {
    color: #666;
    font-size: 8px;
  }
  
  .welcome-actions {
    display: flex;
    gap: 15px;
    
    .action-link {
      color: #666;
      font-size: 13px;
      text-decoration: none;
      
      &:hover {
        color: #ff6700; /* 使用主题色，这里假设是橙色 */
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/base/top.vue